import React from "react";
import { Navigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import DataParser from "../../utlits/Dataparser";

// saasOnly: SaaS-admin area (companies, packages, modules, SaaS users/roles, platform dashboard);
// company users — a Company Admin included — are sent to /unauthorized
const PermissionRoute = ({ requiredPermission, requiredModule, saasOnly = false, children }) => {
    let adminInfo;
    let userRole;
    let permissions = [];

    try {
        const storedInfo = JSON.parse(secureLocalStorage.getItem("adminInfo"));
        if (storedInfo) {
            adminInfo = storedInfo;
            userRole = adminInfo?.user?.userdata?.role_title;
            permissions = adminInfo?.user?.userdata?.user_permissions || [];
        }
    } catch (error) {
        console.error("PermissionRoute: Failed to parse user data", error);
        // If data is corrupted, redirect to login or show unauthorized?
        // Let's assume unauthorized/login for safety
        return <Navigate to="/" />;
    }

    if (!adminInfo) {
        return <Navigate to="/" />;
    }

    // SaaS Admin manages every company's data and isn't restricted by any
    // single company's package modules.
    if (DataParser.IsSaaSAdmin()) {
        return children;
    }
    if (saasOnly) {
        return <Navigate to="/unauthorized" replace />;
    }

    // Module-level gate: whether a feature is in the company's plan at all.
    // Applies to every role — including Company Admin — since it isn't a
    // permission question, it's "did the company pay for this module".
    if (requiredModule && !DataParser.AllowedCompanyModules()?.includes(requiredModule)) {
        console.warn(`⛔ Blocked access to restricted route. Required module: ${requiredModule}`);
        return <Navigate to="/unauthorized" replace />;
    }

    // Company Admin has full permission access (still subject to the module gate above)
    if (userRole?.toLowerCase() === "company admin") {
        return children;
    }

    // Validating if permissions is an array of strings
    let hasPermission = false;
    if (Array.isArray(permissions)) {
        if (Array.isArray(requiredPermission)) {
            // Check if user has AT LEAST ONE of the required permissions (OR logic)
            hasPermission = requiredPermission.some(rp => permissions.includes(rp));
        } else {
            // Single permission check
            hasPermission = permissions.includes(requiredPermission);
        }
    }

    if (!hasPermission) {
        console.warn(`⛔ Blocked access to restricted route. Required: ${requiredPermission}, Have:`, permissions);
        return <Navigate to="/unauthorized" replace />;
    }

    return children;
};

export default PermissionRoute;
